import { lazy } from 'react';
import authRoles from '../../../../auth/authRoles';

const CurrencyPage = lazy(() => import('./CurrencyPage'));

const CurrencyPageConfig = {
   settings: {
      layout: {
         config: {},
      },
   },
   auth: authRoles.user,
   routes: [
      {
         path: '/operator/masterdata/currency',
         element: <CurrencyPage />,
      },
   ],
};

export default CurrencyPageConfig;
